/**
 * @copyright 2026 @ DigiNet
 * @author YENNHI
 * @create 2026/09/30 11:19
 * @update 2026/09/30 11:19
 */


import Api from "../../../services/api";

export function loadForm(params, cb) {
    return async () => {
        await Api.put('/w14f1425/load-form', params)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}
